<template>
  <div>
    <!-- email_taken banner -->
    <div
      v-if="emailTakenBanner"
      class="lp-banner lp-banner--error"
      role="alert"
      aria-live="assertive"
    >מייל זה כבר רשום במערכת. התחבר/י עם הסיסמה שלך.</div>

    <!-- login error banner (replaces alert()) -->
    <div
      v-if="loginError"
      class="lp-banner lp-banner--error"
      role="alert"
      aria-live="assertive"
    >{{ loginError }}</div>

    <!-- ---- Credential form ---- -->
    <div v-if="!show_step_b">
      <div id="dvAjax_signupFRM" class="mtr">
        <form v-on:submit.prevent="login_do()" method="post">
          <ul class="frmUL">
            <li class="">
              <label class="caption" for="login-username">כתובת מייל <span class="mustChar">*</span></label>
              <span class="field">
                <input
                  id="login-username"
                  pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
                  type="email"
                  placeholder="כתובת מייל"
                  v-model="info.username"
                  name="username"
                  aria-required="true"
                >
              </span>
            </li>
            <li class="">
              <label class="caption" for="login-password">סיסמה <span class="mustChar">*</span></label>
              <span class="field lp-pass-wrap">
                <input
                  id="login-password"
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="סיסמה"
                  name="password"
                  v-model="info.password"
                  aria-required="true"
                  autocomplete="current-password"
                >
                <button type="button" class="lp-pass-eye" @click="showPassword = !showPassword" :aria-label="showPassword ? 'הסתר סיסמה' : 'הצג סיסמה'">
                  <svg v-if="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                </button>
              </span>
            </li>
            <li class="sbm_area">
              <UiButton type="submit" variant="primary" size="lg" :block="true" :loading="is_loading">
                התחבר
              </UiButton>
            </li>
          </ul>
          <div class="h5">
            עדיין אינך רשום?
            <button type="button" class="lp-text-btn" @click="$emit('switch-tab', 'signup')">להרשמה לחץ כאן</button>
          </div>
          <button type="button" class="lp-forgot-btn" @click="$emit('forgot-password', info.username)">שכחתי סיסמא</button>
        </form>
      </div>
    </div>

    <!-- ---- SMS confirm step ---- -->
    <div v-if="show_step_b">
      <h3>אנא הזן את הקוד שקיבלת כעת למכשירך</h3>
      <form @submit.prevent="sms_login_confirm()">
        <input id="code_inp" type="number" name="code" placeholder="קוד" ref="code" required value="" class="lp-code-input">
        <div>
          <UiButton type="submit" variant="primary" size="lg" :block="true" :loading="is_loading">
            הכנס
          </UiButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import UiButton from '../ui/Button.vue';

export default {
  name: 'LoginPanel',
  components: { UiButton },

  props: {
    // Pre-filled email when switching from signup (email_taken flow)
    prefillEmail: { type: String, default: '' },
    emailTakenBanner: { type: Boolean, default: false },
  },

  data() {
    return {
      info: {
        username: '',
        password: '',
      },
      token: '',
      show_step_b: false,
      is_loading: false,
      loginError: '',
      showPassword: false,
      fromnews: this.$route.params.news,
      prevRoute: `${this.$route.params.prevpage}?t=`,
    };
  },

  watch: {
    // When parent pre-fills the email (email_taken flow), sync into local state
    prefillEmail(val) {
      if (val) this.info.username = val;
    },
    // Only one banner at a time
    emailTakenBanner(val) {
      if (val) this.loginError = '';
    },
  },

  mounted() {
    if (this.prefillEmail) {
      this.info.username = this.prefillEmail;
    }
  },

  methods: {
    login_do() {
      this.loginError = '';
      this.$emit('clear-email-taken');
      this.is_loading = true;
      this.api_call({
        url: 'login',
        data: this.info,
        onComplete: (data) => {
          this.is_loading = false;
          const token = data && data.data ? data.data.data : null;
          const invalidToken = (
            token === false
            || token === null
            || token === undefined
            || (typeof token === 'string' && (token.trim() === '' || token === 'false'))
          );

          if (invalidToken) {
            this.loginError = 'הפרטים שהזנת אינם נכונים. אנא תקן ונסה שנית.';
            return;
          }

          localStorage.setItem('user_token', token);

          // Ensure token is actually recognized before redirecting.
          this.api_call({
            url: 'general',
            data: { is_profile_valid: false },
            onComplete: (verifyData) => {
              const verifiedUser = verifyData
                && verifyData.data
                && verifyData.data.data
                && verifyData.data.data.user;

              if (verifiedUser && Number(verifiedUser.id) > 0) {
                if (this.fromnews === 'news') {
                  document.location = 'https://news.tov.tv/' + this.prevRoute + token;
                } else {
                  document.location = '/';
                }
                return;
              }

              localStorage.removeItem('user_token');
              this.loginError = 'ההתחברות לא הושלמה. נסה/י שוב בעוד רגע.';
            },
          });
        },
      });
    },

    sms_login() {
      this.loginError = '';
      this.is_loading = true;
      this.api_call({
        url: 'login_phone',
        data: { phone: this.$refs.phone.value },
        onComplete: (data) => {
          this.is_loading = false;
          if (data.data.data !== false) {
            this.token = data.data.data;
            this.show_step_b = true;
          } else {
            this.loginError = 'פרטי ההתחברות אינם נכונים.';
          }
        },
      });
    },

    sms_login_confirm() {
      this.loginError = '';
      this.is_loading = true;
      this.api_call({
        url: 'login_confirm',
        data: { code: this.$refs.code.value, token: this.token },
        onComplete: (data) => {
          if (data.data.data !== false) {
            localStorage.setItem('user_token', data.data.data);
            document.location = '/';
          } else {
            this.loginError = 'פרטי ההתחברות אינם נכונים.';
            this.is_loading = false;
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
#dvAjax_signupFRM {
  width: 100%;
  min-width: 0;
}

/* Forgot password ghost button */
.lp-forgot-btn {
  font-size: 14px;
  margin-block: var(--space-2) 0;
  display: block;
  cursor: pointer;
  background: none;
  border: none;
  color: var(--color-textMuted);
  font-family: var(--font-hebrew);
  padding: var(--space-2) 0;
  text-decoration: underline;
}

.lp-forgot-btn:hover {
  color: var(--color-text);
}

.lp-forgot-btn:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
  border-radius: 2px;
}

/* SMS code input */
.lp-code-input {
  margin-block: var(--space-4);
  display: block;
}

/* Restore hidden labels for accessibility (global SCSS hides .caption) */
label.caption {
  display: block !important;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-textMuted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-block-end: 6px;
  font-family: var(--font-hebrew);
}

/* Focus ring on raw inputs — accent, not plain text */
input:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

/* Password eye toggle */
.lp-pass-wrap {
  position: relative;
  display: block;
}

.lp-pass-eye {
  position: absolute;
  inset-inline-end: var(--space-3, 12px);
  inset-block: 0;
  margin-block: auto;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: var(--color-textMuted);
  display: flex;
  align-items: center;
  height: 32px;
  transition: color 150ms ease;
}

.lp-pass-eye:hover { color: var(--color-text); }
.lp-pass-eye:focus-visible {
  outline: 2px solid var(--color-accent);
  border-radius: 4px;
}

.lp-pass-wrap input[type="password"],
.lp-pass-wrap input[type="text"] {
  padding-inline-start: 42px !important;
}

/* Override global input styles inside login panel for consistency */
input[type="email"],
input[type="password"],
input[type="text"],
input[type="number"] {
  background: var(--color-surface2) !important;
  border: 1px solid var(--color-borderHi) !important;
  border-radius: var(--radius-sm) !important;
  color: var(--color-text) !important;
  font-size: 16px !important;
  font-family: var(--font-hebrew) !important;
  height: 54px !important;
  padding-inline: 16px !important;
  box-sizing: border-box;
  width: 100%;
  transition: border-color 200ms ease, box-shadow 200ms ease;
}

input[type="email"]:focus,
input[type="password"]:focus,
input[type="text"]:focus,
input[type="number"]:focus {
  outline: none !important;
  border-color: var(--color-accent) !important;
  box-shadow: 0 0 0 4px rgba(225, 29, 42, 0.25), 0 0 12px rgba(225, 29, 42, 0.15) !important;
}

/* "Not registered" helper text */
.h5 {
  font-size: var(--text-base);
  color: var(--color-textMuted);
  margin-block: var(--space-4) var(--space-2);
  font-family: var(--font-hebrew);
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

/* Error / info banner */
.lp-banner {
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-sm);
  font-size: 16px;
  margin-block-end: var(--space-4);
  line-height: 1.5;
}

.lp-banner--error {
  background-color: rgba(224, 65, 65, 0.12);
  border: 1px solid rgba(224, 65, 65, 0.33);
  color: #ffffff;
}

/* Text link button */
.lp-text-btn {
  background: none;
  border: none;
  color: var(--color-accent);
  font-size: inherit;
  font-family: inherit;
  cursor: pointer;
  padding: 4px 0;
  text-decoration: underline;
}

.lp-text-btn:focus-visible {
  outline: 2px solid var(--color-accent);
  border-radius: 2px;
}

@media only screen and (max-width: 600px) {
  #dvAjax_signupFRM {
    min-width: 0;
    width: 100%;
  }

  input[type="email"],
  input[type="password"],
  input[type="text"],
  input[type="number"] {
    font-size: 16px !important; /* prevent iOS zoom on focus */
  }
}

@media (prefers-reduced-motion: reduce) {
  input[type="email"],
  input[type="password"],
  input[type="text"],
  input[type="number"] {
    transition: none;
  }
}
</style>
